// extracted by mini-css-extract-plugin
export var card = "BulletsCard-module--card--1fdf9";
export var count = "BulletsCard-module--count--d8cad";
export var countDescription = "BulletsCard-module--countDescription--26731";
export var fadeInAnimation = "BulletsCard-module--fadeInAnimation--59d72";